import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getVisitorId() {
  let id = localStorage.getItem("noxway_vid");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("noxway_vid", id);
  }
  return id;
}

export function getReferralCode() {
  return localStorage.getItem("noxway_ref") || null;
}

export function captureRef() {
  const ref = new URLSearchParams(window.location.search).get("ref");
  if (ref) localStorage.setItem("noxway_ref", ref);
}

export function hasConsent() {
  return localStorage.getItem("noxway_consent") === "yes";
}

export async function grantConsent() {
  localStorage.setItem("noxway_consent", "yes");
  await axios.post(`${API}/visitor/event`, { visitor_id: getVisitorId(), type: "consent", consent: true }).catch(() => {});
  await trackRefClick();
  await trackEvent("page_view");
}

export function denyConsent() {
  localStorage.setItem("noxway_consent", "no");
  axios.post(`${API}/visitor/event`, { visitor_id: getVisitorId(), type: "consent", consent: false }).catch(() => {});
}

export async function trackEvent(type) {
  if (!hasConsent()) return;
  axios.post(`${API}/visitor/event`, {
    visitor_id: getVisitorId(), type, path: window.location.pathname, consent: true,
  }).catch(() => {});
}

export async function trackRefClick() {
  const code = getReferralCode();
  if (!code || sessionStorage.getItem("noxway_ref_tracked")) return;
  sessionStorage.setItem("noxway_ref_tracked", "1");
  axios.post(`${API}/ref/track`, { code, visitor_id: getVisitorId() }).catch(() => {});
}
